import Vue from "vue";
import VueRouter from "vue-router";
import i18n from "../i18n";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Root",
    component: () => import("../screens/TabScreen.vue")
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {
  const lang = to.query.lang;

  if (lang === "ru" || lang === "kz") {
    i18n.locale = lang;
  } else {
    i18n.locale = "ru";
  }

  next();
});

export default router;
